import React, {useEffect, useState} from "react";
import AdminPanelLayaut from "./layaut/AdminPanelLayaut";
import {getZgloszenia} from "../Services";
import {Table} from "antd";
import dayjs from "dayjs";
import {Link} from "react-router-dom";
import {isEmpty} from "../../../GlobalServices";

const Zgloszenia = () => {
    const [zgloszenia, setZgloszenia] = useState();

    useEffect(() => {
        pobierzZgloszenia();
    }, []);

    const pobierzZgloszenia = () => {
        getZgloszenia().then((response) => {
            setZgloszenia(response.data);
        }).catch((error) => {
            console.log(error);
        })
    }

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Numer',
            dataIndex: 'numer',
            key: 'numer',
            render: (data: any, row: any) => <Link to={`/admin/zgloszenia/${row.id}`}>{data}</Link>,
        },
        {
            title: 'Imię',
            dataIndex: 'imie',
            key: 'imie',
        },
        {
            title: 'Nazwisko',
            dataIndex: 'nazwisko',
            key: 'nazwisko',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Miejsce',
            dataIndex: 'miejsce',
            key: 'miejsce',
        },
        {
            title: 'Kiedy',
            dataIndex: 'dataOd',
            key: 'dataOd',
            render: (data: any, row: any) => (isEmpty(row.dataOd) || isEmpty(row.dataOd)) ? null : <div>{dayjs(row.dataOd).format('YYYY-MM-DD')} - {dayjs(row.dataDo).format('YYYY-MM-DD')}</div>,
        },
        {
            title: 'Kogo dotyczy',
            dataIndex: 'kogoDotyczy',
            key: 'kogoDotyczy',
        },
        {
            title: 'Opis',
            dataIndex: 'opis',
            key: 'opis',
        },
        {
            title: 'Data wpisu',
            dataIndex: 'dataWpisu',
            key: 'dataWpisu',
            render: (data: any) => dayjs(data).format('YYYY-MM-DD HH:mm'),

        },
    ];

    return (
        <AdminPanelLayaut label={'Zgłoszenia'}>
            <Table dataSource={zgloszenia} columns={columns} />
        </AdminPanelLayaut>
    )
}

export default Zgloszenia;
